// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IRawStyle } from "@fluentui/react";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { HighContrastSelector } from "@fluentui/react";

import { commonHighContrastDisabledStyles } from "@1js/acui-common";

import type { RibbonMode } from "./components";
import {
  nextStylesMLRBottomBarHeight,
  baseTopBarHeight,
  bottomBarHeightSLR,
  slrDividerPadding,
} from "./ribbonStylingConstantsBase";
import { ribbonComboboxDisabledStyles } from "./Controls/RibbonComboBox/next/useRibbonComboboxStyles.styles";
import { isNextStyleEnabled } from "@1js/acui-theme";
import { ribbonComboboxFastDisabledTargetClass } from "@1js/acui-font-picker";

export const ribbonBottomBarZIndex = 2;
export const labelContainerHeight = 12;
export const multiRowMaxGap = 4;
export const vNextTopBottomMargin = 4;

export function getLabelContainerHeight() {
  return isNextStyleEnabled() ? 14 : labelContainerHeight;
}
export interface RibbonBottomBarStylingConstants {
  bottomBarHeight: number;
  groupDividerPadding: {
    top: number;
    right: number;
    bottom: number;
    left: number;
  };
}

const RibbonBottomBarStylingConstantsSLR: RibbonBottomBarStylingConstants = {
  bottomBarHeight: bottomBarHeightSLR,
  groupDividerPadding: {
    top: slrDividerPadding,
    right: slrDividerPadding,
    bottom: slrDividerPadding,
    left: slrDividerPadding,
  },
};

function getRibbonBottomBarStylingConstantsMLR(): RibbonBottomBarStylingConstants {
  return {
    bottomBarHeight: isNextStyleEnabled() ? nextStylesMLRBottomBarHeight : 90,
    groupDividerPadding: isNextStyleEnabled()
      ? { top: 0, right: 8, bottom: 0, left: 8 }
      : { top: 0, right: 8, bottom: 2, left: 8 },
  };
}

let customRibbonBottomBarReservedSpace: number = 0;

export function setCustomRibbonBottomBarReservedSpace(reservedSpace: number) {
  customRibbonBottomBarReservedSpace = reservedSpace;
}

export function getRibbonBottomBarContainerWidth(): string {
  return customRibbonBottomBarReservedSpace > 0
    ? `calc(100% - ${customRibbonBottomBarReservedSpace}px)`
    : "100%";
}

let customRibbonBottomBarStylingConstants:
  | RibbonBottomBarStylingConstants
  | undefined = undefined;

export function setCustomRibbonBottomBarStylingConstants(
  customConstants?: RibbonBottomBarStylingConstants
) {
  customRibbonBottomBarStylingConstants = customConstants;
}

export function getRibbonBottomBarStylingConstants(
  mode: RibbonMode
): RibbonBottomBarStylingConstants {
  if (customRibbonBottomBarStylingConstants) {
    return customRibbonBottomBarStylingConstants;
  }

  return mode === "SingleLine"
    ? RibbonBottomBarStylingConstantsSLR
    : getRibbonBottomBarStylingConstantsMLR();
}

export interface RibbonTopBarStylingConstants {
  topBarHeight: number;
  tabHeaderHeight: number;
}

const ribbonTopBarStylingConstants: RibbonTopBarStylingConstants = {
  topBarHeight: baseTopBarHeight,
  tabHeaderHeight: 31,
};

let customRibbonTopBarReservedSpace: number = 0;

export function setCustomRibbonTopBarReservedSpace(reservedSpace: number) {
  customRibbonTopBarReservedSpace = reservedSpace;
}

export function getRibbonTopBarContainerWidth(): string {
  return customRibbonTopBarReservedSpace > 0
    ? `calc(100% - ${customRibbonTopBarReservedSpace}px)`
    : "100%";
}

let customRibbonTopBarStylingConstants:
  | RibbonTopBarStylingConstants
  | undefined = undefined;

export function setCustomRibbonTopBarStylingConstants(
  customConstants?: RibbonTopBarStylingConstants
) {
  customRibbonTopBarStylingConstants = customConstants;
}

export function getRibbonTopBarStylingConstants(): RibbonTopBarStylingConstants {
  return customRibbonTopBarStylingConstants || ribbonTopBarStylingConstants;
}

export const fastDisabled: IRawStyle = {
  selectors: {
    ["&"]: {
      opacity: 0.4,
      pointerEvents: "none",
    },
    // Make sure all appropriate content is styled as disabled in HC
    ['&, & button, & input[type="text"], & div, & span, & label']: [
      commonHighContrastDisabledStyles,
      {
        selectors: {
          [HighContrastSelector]: {
            backgroundColor: "transparent",
            selectors: {
              ['[aria-pressed="true"], [aria-checked="true"]']: {
                backgroundColor: "highlight",
              },
            },
          },
        },
      },
    ],
    [`.${ribbonComboboxFastDisabledTargetClass}`]: ribbonComboboxDisabledStyles,
  },
};
